import { Dispatch, SetStateAction, createContext } from 'react';

export enum SelectedDiffType {
  All,
  Cslr,
  Single,
  Custom,
  None,
}

export type MultiCommitSelection = {
  sourceCommit: BB.Commit | undefined;
  sourceIndex: number;
  destinationCommit: BB.Commit | undefined;
  destinationIndex: number;
};

export const defaultMultiCommitSelection: MultiCommitSelection = {
  sourceCommit: undefined,
  sourceIndex: -1,
  destinationCommit: undefined,
  destinationIndex: -1,
};

export type IterativeReviewSelectedDiffState = {
  sourceHash: string;
  destHash?: string;
  isLoading: boolean;
  selectedDiffType: SelectedDiffType;
};

type DiffStateContext = {
  iterativeReviewSelectedDiff: IterativeReviewSelectedDiffState;
  setIterativeReviewSelectedDiff: Dispatch<
    SetStateAction<IterativeReviewSelectedDiffState>
  >;
  multiCommitSelection: MultiCommitSelection;
  setMultiCommitSelection: Dispatch<SetStateAction<MultiCommitSelection>>;
  activeIndex: number;
  setActiveIndex: Dispatch<SetStateAction<number>>;
  commitCSLRHash: string;
  setCommitCSLRHash: Dispatch<SetStateAction<string>>;
};

const initialState: DiffStateContext = {
  iterativeReviewSelectedDiff: {
    sourceHash: '',
    isLoading: true,
    selectedDiffType: SelectedDiffType.None,
  },
  multiCommitSelection: defaultMultiCommitSelection,
  activeIndex: -1,
  commitCSLRHash: '',
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setIterativeReviewSelectedDiff: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setMultiCommitSelection: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setActiveIndex: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setCommitCSLRHash: () => {},
};

export const DiffStateContext = createContext(initialState);
